export default "__VITE_ASSET__CVvhiiZY__"